import type { FunctionComponent } from "react";

export const DHLLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/DHL_Logo.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="DHL"
    />
  );
};
